function Disclaimer() {
  return (
    <>
      <section className="page-header text-center text-white">
        <div className="container">
          <h1 className="fw-bold">Disclaimer</h1>
          <p className="mb-0 opacity-75">Last updated: June 2025</p>
        </div>
      </section>

      <section className="py-5">
        <div className="container policy-content">
          <h4>1. General Information</h4>
          <p>The information provided on the Garvit Education website is for general informational purposes only. While we strive to keep the information accurate and up-to-date, we make no representations or warranties of any kind about the completeness, accuracy, or reliability of the information.</p>

          <h4>2. No Guarantee of Outcomes</h4>
          <p>Garvit Education does not guarantee:</p>
          <ul>
            <li>Specific job placements or employment after course completion</li>
            <li>Specific salary packages or career advancement</li>
            <li>Passing of examinations or certifications</li>
            <li>Admission to higher education institutions</li>
          </ul>
          <p>Career outcomes depend on individual effort, market conditions, and various other factors beyond our control.</p>

          <h4>3. Third-Party Links</h4>
          <p>Our website may contain links to third-party websites. We do not control and are not responsible for the content, privacy policies, or practices of any third-party sites.</p>

          <h4>4. Testimonials & Success Stories</h4>
          <p>Testimonials and success stories displayed on our website represent individual experiences and results. They are not guaranteed outcomes for all students.</p>

          <h4>5. Course Information</h4>
          <p>Course details, fees, schedules, and other program information are subject to change without prior notice. Please confirm current details with our admissions team before enrollment.</p>

          <h4>6. University Affiliation</h4>
          <p>Garvit Education operates as a skill development center. Degree programs are offered in collaboration with UGC-recognized universities. The awarding of degrees is subject to the policies and regulations of the respective universities.</p>

          <h4>7. Contact Us</h4>
          <p>For any clarifications:</p>
          <p><strong>Email:</strong> support@gencollege.in</p>
        </div>
      </section>
    </>
  );
}

export default Disclaimer;
